import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import {
  DoubleTextSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../DynamicAsset/components/AssetsLoading';

const Mobile = () => (
  <TableContent direction="column" bg={'backgroundlight'} space={Spacing['inline.xxxs']}>
    <HStack w={'full'} alignItems={'center'} justifyContent={'space-between'}>
      <HStack alignItems={'center'} space={Spacing['inline.nano']}>
        <Skeleton
          w="50px"
          h="50px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <VStack w={'90px'} space={Spacing['inline.nano']}>
          <TextSkeleton w={'full'} />
          <TextSkeleton w={'full'} />
        </VStack>
      </HStack>
      <VStack w={'120px'} space={Spacing['inline.quarck']}>
        <TextSkeleton w={'80%'} />
        <TextSkeleton w={'full'} />
        <TextSkeleton w={'full'} h={Typography['fontsize.xs']} />
      </VStack>
    </HStack>
    <HStack
      w={'full'}
      space={Spacing['inline.nano']}
      alignItems={'center'}
      justifyContent={'space-between'}>
      <VStack w={'90px'} space={Spacing['inline.quarck']}>
        <TextSkeleton w={'full'} />
        <TextSkeleton w={'full'} />
      </VStack>
      <VStack w={'90px'} space={Spacing['inline.quarck']}>
        <TextSkeleton w={'full'} />
        <TextSkeleton w={'full'} />
      </VStack>
      <VStack w={'90px'} space={Spacing['inline.quarck']}>
        <TextSkeleton w={'full'} />
        <TextSkeleton w={'full'} />
      </VStack>
    </HStack>
    <VStack w={'full'} space={Spacing['inline.quarck']}>
      <TextSkeleton w={'40%'} />
      <InputSkeleton />
    </VStack>
    <VStack w={'full'} space={Spacing['inline.quarck']}>
      <TextSkeleton w={'40%'} />
      <InputSkeleton />
    </VStack>
    <HStack
      w={'full'}
      alignItems={'center'}
      space={Spacing['inline.xxxs']}
      justifyContent={'space-between'}>
      <VStack space={Spacing['inline.quarck']}>
        <TextSkeleton w={'200px'} h={Typography['fontsize.xl']} />
        <TextSkeleton w={'200px'} />
      </VStack>
      <Skeleton
        w="40px"
        h="40px"
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
    </HStack>
  </TableContent>
);

const Tablet = () => (
  <TableContent direction="column" bg={'backgroundlight'} space={Spacing['inline.xxxs']}>
    <HStack
      flex={1}
      w={'full'}
      space={Spacing['inline.xxxs']}
      alignItems="center"
      justifyContent={'space-between'}>
      <HStack flex={1} maxW={'170px'} space={Spacing['inline.xxxs']} alignItems="center">
        <Skeleton
          w="40px"
          h="40px"
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <DoubleTextSkeleton w={'100px'} />
      </HStack>
      <HStack flex={1} alignItems={'center'} space={Spacing['inline.xxxs']}>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TextSkeleton w={'80%'} />
          <DoubleTextSkeleton w={'full'} />
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <DoubleTextSkeleton w={'full'} />
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <DoubleTextSkeleton w={'full'} />
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <DoubleTextSkeleton w={'full'} />
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <DoubleTextSkeleton w={'full'} />
        </TableContentItemColumn>
      </HStack>
    </HStack>
    <HStack flex={1} space={Spacing['inline.xxs']} w={'full'} alignItems={'center'}>
      <TableContentItemColumn space={Spacing['inline.quarck']} maxW={'200px'}>
        <TextSkeleton />
        <InputSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton />
        <InputSkeleton />
      </TableContentItemColumn>
      <DoubleTextSkeleton w={'100px'} />
      <Skeleton
        w="40px"
        h="40px"
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
    </HStack>
  </TableContent>
);

const Desktop = () => (
  <TableContent direction="row" bg={'backgroundlight'}>
    <HStack flex={0.4} space={Spacing['inline.xxxs']} alignItems="center">
      <Skeleton
        w="40px"
        h="40px"
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
      <DoubleTextSkeleton w={'100px'} />
    </HStack>
    <HStack
      flex={1}
      space={Spacing['inline.xxxs']}
      alignItems="center"
      justifyContent={'space-between'}>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton w={'80%'} />
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton />
        <InputSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <TextSkeleton />
        <InputSkeleton />
      </TableContentItemColumn>
      <TableContentItemColumn space={Spacing['inline.quarck']}>
        <DoubleTextSkeleton w={'full'} />
      </TableContentItemColumn>
      <Skeleton
        w="40px"
        h="40px"
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
    </HStack>
  </TableContent>
);

export const AddedProductItemEquitySkeleton: React.FC = () => {
  const layout = useBreakpointValue({ base: <Mobile />, sm: <Tablet />, lg: <Desktop /> });

  return layout;
};
